import { Image } from "@chakra-ui/react";
import styled from "styled-components";

export const SDGImage = styled(Image)`
	width: 5rem;
	height: 5rem;
	margin: 0.2rem;
	display: inline;
`;
